import React from 'react';
import { Progress as AntProgress } from 'antd';

/**
 * Wrapper component for Ant Design Progress
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Progress functionality including percent, status, type, and strokeColor options.
 * 
 * @component
 * @example
 * import { Progress } from '../GeneralComponents/ui';
 * 
 * <Progress percent={30} />
 * <Progress percent={50} status="active" />
 * <Progress percent={70} status="exception" />
 * <Progress percent={100} />
 * <Progress percent={50} showInfo={false} />
 * <Progress type="circle" percent={75} />
 * 
 * @see https://ant.design/components/progress/ - Ant Design Progress documentation
 */
const Progress = (props) => {
  return <AntProgress {...props} />;
};

export default Progress;

